import { render, staticRenderFns } from "./RccdP_List.vue?vue&type=template&id=9122a5b6"
import script from "./RccdP_List.vue?vue&type=script&lang=js"
export * from "./RccdP_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports